// import React, { useState, useEffect } from "react";
// import { FaArrowUp, FaDollarSign, FaWallet } from "react-icons/fa";
// import {
//   MdCreditScore,
//   MdLocalHospital,
//   MdOutlineAutoGraph,
//   MdPeopleAlt,
// } from "react-icons/md";
// import toast from "react-hot-toast";
// // import "./Style.css";
// import { Sector } from "recharts";
// import { FaArrowDown } from "react-icons/fa";
// import { AiOutlineEye, AiOutlineStock } from "react-icons/ai";
// import { IoLocationSharp } from "react-icons/io5";
// import { RiExchangeDollarLine } from "react-icons/ri";
// import { BsBank2 } from "react-icons/bs";
// import { IoMdCash } from "react-icons/io";
// import {
//   FaMoneyCheckDollar,
//   FaSackDollar,
//   FaUserDoctor,
// } from "react-icons/fa6";
// import doctorService from "../../Services/doctorService";
// import { PeopleAltOutlined, Shop, ShoppingBag } from "@mui/icons-material";
// import patientService from "../../Services/patientService";
// import saleService from "../../Services/saleService";
// import staffService from "../../Services/staffService";
// import ServicesInvoiceModal from "../../Components/ServicesInvoiceModal";
// import MedicinesInvoiceModal from "../../Components/MedicinesInvoiceModal";
// import PatientsModal from "../../Components/PatientsModal";
// import PharmacyInvoicesModal from "../../Components/PharmacyInvoicesModal ";
// import pnlService from "../../Services/pnlService";
// import { TbBedFlatFilled } from "react-icons/tb";
// import { GiMedicines } from "react-icons/gi";
// import { BiSolidInjection } from "react-icons/bi";
// import DoughnutChart from "../../Components/DoughnutChart";
// import LineChart from "../../Components/LineChart";
// import BarChart from "../../Components/BarChart";

// const AdminDashboard = () => {
//   const [select, setselect] = useState(false);
//   const [activeIndex, setactiveIndex] = useState(0);
//   const [patients, setPatients] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [doctors, setDoctors] = useState([]);
//   const [sales, setSales] = useState([]);
//   const [todayProfit, setTodayProfit] = useState([]);
//   const [salesInvoices, setSalesInvoices] = useState([]);
//   const [monthSales, setMonthSales] = useState([]);

//   const [patientsSales, setPatientsSales] = useState([]);
//   const [medicineSales, setMedicineSales] = useState([]);
//   const [servicesSales, setServicesSales] = useState([]);
//   const [staffTotal, setStaffTotal] = useState([]);

//   const [feeTotal, setFeeTotal] = useState([]);
//   const [mSalesTotal, setMSalesTotal] = useState([]);
//   const [patientsSalesTotal, setPatientsSalesTotal] = useState([]);
//   const [medicinesSalesTotal, setMedicinesSalesTotal] = useState([]);
//   const [servicesSalesTotal, setServicesSalesTotal] = useState([]);
//   const [pharmacySalesTotal, setPharmacySalesTotal] = useState([]);

//   const [price, setPrice] = useState("");
//   const [medicinesGroupedData, setMedicinesGroupedData] = useState([]);
//   const [servicesGroupedData, setServicesGroupedData] = useState([]);
//   const [pharmacyGroupedData, setPharmacyGroupedData] = useState([]);

//   const [selectedInvoices, setSelectedInvoices] = useState([]);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const [selectedMInvoices, setSelectedMInvoices] = useState([]);
//   const [isMModalOpen, setMIsModalOpen] = useState(false);

//   const [selectedPatients, setSelectedPatients] = useState([]);
//   const [isPModalOpen, setIsPModalOpen] = useState(false);
//   const [totalPatients, setTotalPatients] = useState(0);
//   const [pharmacySales, setPharmacySales] = useState([]);

//   const [selectedPharmacyInvoices, setSelectedPharmacyInvoices] =
//     useState(null);
//   const [isPharmacyModalOpen, setIsPharmacyModalOpen] = useState(false);

//   const formatDate = (dateString) => {
//     if (!dateString) return "";
//     const options = { year: "numeric", month: "short", day: "numeric" };
//     return new Date(dateString).toLocaleDateString("en-PK", options);
//   };

//   useEffect(() => {
//     const getDoctors = async () => {
//       try {
//         setLoading(true);
//         const response = await doctorService.fetchTotal();
//         console.log(response);
//         setDoctors(response.total);
//         setLoading(false);
//       } catch (error) {
//         setLoading(false);
//         toast.error("Error fetching doctors");
//       }
//     };
//     getDoctors();
//   }, []);

//   useEffect(() => {
//     const getPatients = async () => {
//       try {
//         setLoading(true);
//         const response = await patientService.fetchTotal();
//         console.log(response);
//         setPatients(response.total);
//         setLoading(false);
//       } catch (error) {
//         setLoading(false);
//         toast.error("Error fetching doctors");
//       }
//     };
//     getPatients();
//   }, []);

//   useEffect(() => {
//     const getStaff = async () => {
//       try {
//         setLoading(true);
//         const response = await staffService.fetchTotal();
//         console.log(response);
//         setStaffTotal(response.total);
//         setLoading(false);
//       } catch (error) {
//         setLoading(false);
//         toast.error("Error fetching doctors");
//       }
//     };
//     getStaff();
//   }, []);

//   useEffect(() => {
//     const getFees = async () => {
//       try {
//         setLoading(true);
//         const response = await saleService.fetchPnl();
//         console.log(response);
//         setFeeTotal(response.Checkup_Fee);
//         setLoading(false);
//       } catch (error) {
//         setLoading(false);
//         toast.error("Error fetching doctors");
//       }
//     };
//     getFees();
//   }, []);

//   useEffect(() => {
//     const getSalesTotal = async () => {
//       try {
//         setLoading(true);
//         const response = await saleService.fetchPnl();
//         console.log(response);
//         setMSalesTotal(response.total_medicine_services_sale);
//         setLoading(false);
//       } catch (error) {
//         setLoading(false);
//         toast.error("Error fetching doctors");
//       }
//     };
//     getSalesTotal();
//   }, []);

//   useEffect(() => {
//     const getPSales = async () => {
//       try {
//         setLoading(true);
//         const response = await saleService.fetchAllPatients();

//         const sortedSales = response.sales.sort(
//           (a, b) => new Date(b.date) - new Date(a.date),
//         );

//         const sevenDaysAgo = new Date();
//         sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 14);
//         sevenDaysAgo.setHours(0, 0, 0, 0);
//         const filteredSales = sortedSales.filter((sale) => {
//           const saleDate = new Date(sale.date);
//           return saleDate >= sevenDaysAgo;
//         });

//         const groupedSales = filteredSales.reduce((acc, sale) => {
//           const date = formatDate(sale.date);
//           if (!acc[date])
//             acc[date] = { totalAmount: 0, totalPatients: 0, sales: [] };
//           acc[date].totalAmount += sale.fee;
//           acc[date].totalPatients += 1; // Count total patients
//           acc[date].sales.push(sale);
//           return acc;
//         }, {});

//         // Set the grouped sales in the state
//         setPatientsSales(
//           Object.entries(groupedSales).map(([date, data]) => ({
//             date,
//             totalAmount: data.totalAmount,
//             totalPatients: data.totalPatients, // Number of patients for the day
//             sales: data.sales,
//           })),
//         );
//         setLoading(false);
//       } catch (error) {
//         setLoading(false);
//         console.error("Error fetching sales:", error);
//       }
//     };
//     getPSales();
//   }, []);

//   const handleViewPatients = (sales) => {
//     setSelectedPatients(sales);
//     setIsPModalOpen(true);
//   };

//   useEffect(() => {
//     const fetchSalesData = async () => {
//       try {
//         setLoading(true);
//         const response = await saleService.fetchAllMedicinesSales();

//         const fifteenDaysAgo = new Date();
//         fifteenDaysAgo.setDate(fifteenDaysAgo.getDate() - 14);
//         fifteenDaysAgo.setHours(0, 0, 0, 0); // Start of the day for consistency

//         const recentSales = response.sales.filter((sale) => {
//           const saleDate = new Date(sale.sale_date);
//           return saleDate >= fifteenDaysAgo;
//         });

//         const grouped = groupByDate(recentSales);
//         setMedicinesGroupedData(grouped);
//         setLoading(false);
//       } catch (error) {
//         setLoading(false);
//         toast.error("Error fetching medicines sales data");
//       }
//     };

//     fetchSalesData();
//   }, []);

//   useEffect(() => {
//     const fetchSalesData = async () => {
//       try {
//         setLoading(true);
//         const response = await saleService.fetchAllServicesSale();

//         const fifteenDaysAgo = new Date();
//         fifteenDaysAgo.setDate(fifteenDaysAgo.getDate() - 14);
//         fifteenDaysAgo.setHours(0, 0, 0, 0);

//         const recentSales = response.sales.filter((sale) => {
//           const saleDate = new Date(sale.sale_date);
//           return saleDate >= fifteenDaysAgo;
//         });

//         const grouped = groupByDate(recentSales);
//         setServicesGroupedData(grouped);
//         setLoading(false);
//       } catch (error) {
//         setLoading(false);
//         toast.error("Error fetching medicines sales data");
//       }
//     };

//     fetchSalesData();
//   }, []);

//   useEffect(() => {
//     const fetchAllPharmacySales = async () => {
//       try {
//         setLoading(true);
//         const response = await saleService.fetchAllPharmacySales();

//         const today = new Date();
//         const last15Days = [];
//         for (let i = 14; i >= 0; i--) {
//           const date = new Date();
//           date.setDate(today.getDate() - i);
//           last15Days.push(date.toLocaleDateString());
//         }

//         let groupedSales = {};
//         if (response && response.sales) {
//           groupedSales = response.sales.reduce((acc, sale) => {
//             const saleDate = new Date(sale.date).toLocaleDateString();
//             if (!acc[saleDate]) {
//               acc[saleDate] = {
//                 date: saleDate,
//                 totalAmount: 0,
//                 invoiceCount: 0,
//                 invoices: [],
//               };
//             }
//             acc[saleDate].totalAmount += parseFloat(sale.amount);
//             acc[saleDate].invoiceCount += 1;
//             acc[saleDate].invoices.push(sale);
//             return acc;
//           }, {});
//         }

//         let formattedData = last15Days.map((date) => ({
//           date,
//           totalAmount: groupedSales[date]?.totalAmount || 0,
//           invoiceCount: groupedSales[date]?.invoiceCount || 0,
//           invoices: groupedSales[date]?.invoices || [],
//         }));

//         formattedData.reverse();
//         setPharmacySales(formattedData);
//         setLoading(false);
//       } catch (error) {
//         console.error("Error fetching all sales:", error);
//         setLoading(false);
//       }
//     };

//     fetchAllPharmacySales();
//   }, []);

//   const handleViewPharmacyInvoice = (date) => {
//     const selectedData = pharmacySales.find((item) => item.date === date);
//     setSelectedPharmacyInvoices(selectedData?.invoices || []);
//     setIsPharmacyModalOpen(true);
//   };

//   const groupByDate = (sales) => {
//     const dateMap = {};
//     const allDates = getAllDatesInRange();

//     sales.forEach((sale) => {
//       const { invoice, unit_price, quantity, sale_date } = sale;
//       const total = quantity * unit_price;
//       const dateKey = formatDate(sale_date);

//       if (!dateMap[dateKey]) {
//         dateMap[dateKey] = {
//           date: dateKey,
//           totalAmount: 0,
//           invoices: new Set(),
//         };
//       }

//       dateMap[dateKey].totalAmount += total;
//       dateMap[dateKey].invoices.add(invoice);
//     });

//     allDates.forEach((date) => {
//       if (!dateMap[date]) {
//         dateMap[date] = {
//           date,
//           totalAmount: 0,
//           invoices: new Set(),
//         };
//       }
//     });

//     const sortedData = Object.values(dateMap)
//       .map((group) => ({
//         ...group,
//         totalInvoiceCount: group.invoices.size,
//       }))
//       .sort((a, b) => new Date(b.date) - new Date(a.date));

//     return sortedData;
//   };

//   const getAllDatesInRange = () => {
//     const today = new Date();
//     const allDates = [];

//     for (let i = 0; i < 10; i++) {
//       const date = new Date(today);
//       date.setDate(today.getDate() - i);
//       allDates.push(formatDate(date));
//     }

//     return allDates;
//   };

//   const handleViewInvoices = async (date) => {
//     try {
//       const response = await saleService.fetchAllServicesSale();
//       const filteredInvoices = response.sales.filter(
//         (sale) => formatDate(sale.sale_date) === date,
//       );
//       setSelectedInvoices(filteredInvoices);
//       setIsModalOpen(true);
//     } catch (error) {
//       console.error("Error fetching invoices:", error);
//     }
//   };

//   const handleMViewInvoices = async (date) => {
//     try {
//       const response = await saleService.fetchAllMedicinesSales();
//       const filteredInvoices = response.sales.filter(
//         (sale) => formatDate(sale.sale_date) === date,
//       );
//       setSelectedMInvoices(filteredInvoices);
//       setMIsModalOpen(true);
//     } catch (error) {
//       console.error("Error fetching invoices:", error);
//     }
//   };

//   const formatAmount = (amount) => {
//     return parseInt(amount || 0).toLocaleString();
//   };

//   const handleCloseModal = () => {
//     setSelectedPharmacyInvoices(null); // Reset invoices when closing
//     setIsPharmacyModalOpen(false); // Close the modal
//   };

//   useEffect(() => {
//     const fetchPatientsSales = async () => {
//       try {
//         setLoading(true);
//         const response = await pnlService.fetchCheckupbyMonth();
//         if (response.responseCode === 200) {
//           const latestMonth = response.Medicines.reduce((latest, current) =>
//             new Date(`${current.year}-${current.month_name}-01`) >
//             new Date(`${latest.year}-${latest.month_name}-01`)
//               ? current
//               : latest,
//           );

//           setPatientsSalesTotal({
//             total_checkup_fee: latestMonth.total_checkup_fee,
//             month_name: latestMonth.month_name,
//           });
//         } else {
//           toast.error("Failed to fetch Checkup data");
//         }
//       } catch (error) {
//         toast.error("Error fetching Checkup data");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchPatientsSales();
//   }, []);

//   useEffect(() => {
//     const fetchMedicinesSales = async () => {
//       try {
//         setLoading(true);
//         const response = await pnlService.fetchMedicinebyMonth();
//         if (response.responseCode === 200) {
//           const latestMonth = response.Medicines.reduce((latest, current) =>
//             new Date(`${current.year}-${current.month_name}-01`) >
//             new Date(`${latest.year}-${latest.month_name}-01`)
//               ? current
//               : latest,
//           );

//           setMedicinesSalesTotal({
//             total_medicines_sale: latestMonth.total_medicines_sale,
//             month_name: latestMonth.month_name,
//           });
//         } else {
//           toast.error("Failed to fetch Checkup data");
//         }
//       } catch (error) {
//         toast.error("Error fetching Checkup data");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchMedicinesSales();
//   }, []);

//   useEffect(() => {
//     const fetchServices = async () => {
//       try {
//         setLoading(true);
//         const response = await pnlService.fetchServicesbyMonth();
//         if (response.responseCode === 200) {
//           const latestMonth = response.Services.reduce((latest, current) =>
//             new Date(`${current.year}-${current.month_name}-01`) >
//             new Date(`${latest.year}-${latest.month_name}-01`)
//               ? current
//               : latest,
//           );

//           setServicesSalesTotal({
//             total_medicines_sale: latestMonth.total_medicines_sale,
//             month_name: latestMonth.month_name,
//           });
//         } else {
//           toast.error("Failed to fetch services data");
//         }
//       } catch (error) {
//         toast.error("Error fetching services data");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchServices();
//   }, []);

//   useEffect(() => {
//     const fetchServices = async () => {
//       try {
//         setLoading(true);
//         const response = await pnlService.fetchPharmacybyMonth();
//         if (response.responseCode === 200) {
//           const latestMonth = response.Pharmacy.reduce((latest, current) =>
//             new Date(`${current.year}-${current.month_name}-01`) >
//             new Date(`${latest.year}-${latest.month_name}-01`)
//               ? current
//               : latest,
//           );

//           setPharmacySalesTotal({
//             total_amount: latestMonth.total_amount,
//             month_name: latestMonth.month_name,
//           });
//         } else {
//           toast.error("Failed to fetch Pharmacy data");
//         }
//       } catch (error) {
//         toast.error("Error fetching Pharmacy data");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchServices();
//   }, []);

//   return (
//     <div>
//       <div className=" flex max-md:flex-col gap-[2%] ">
//         <div className="w-[100%] max-md:w-[100%]">
//           <div className="w-full flex flex-row justify-between gap-4">
//             <div className="w-[70%] grid grid-cols-3 gap-4">
//               <div className="p-3 bg-white shadow-xl border border-gray-300 rounded-2xl">
//                 <div className="bg-gray-800 flex flex-row gap-2 items-center text-white p-2 rounded-md">
//                   <TbBedFlatFilled size={25} />
//                   <p className="font-bold text-xs">Total Patients</p>
//                 </div>
//                 <h1 className="font-extrabold text-4xl text-center my-6 text-[#F07F1B]">
//                   {loading ? "Loading..." : patients}
//                 </h1>
//               </div>
//               <div className="p-3 bg-white shadow-xl border border-gray-300 rounded-2xl">
//                 <div className="bg-gray-800 flex flex-row gap-2 items-center text-white p-2 rounded-md">
//                   <MdPeopleAlt size={25} />
//                   <p className="font-bold text-xs">Total Staff</p>
//                 </div>
//                 <h1 className="font-extrabold text-4xl text-center my-6 text-[#F07F1B]">
//                   {loading ? "Loading..." : staffTotal}
//                 </h1>
//               </div>
//               <div className="p-3 bg-white shadow-xl border border-gray-300 rounded-2xl">
//                 <div className="bg-gray-800 flex flex-row gap-2 items-center text-white p-2 rounded-md">
//                   <FaUserDoctor size={25} />
//                   <p className="font-bold text-xs">Patients Sales</p>
//                 </div>
//                 <div className="my-6 flex flex-row justify-center">
//                   <h1 className="font-extrabold text-4xl text-center text-[#F07F1B]">
//                     {loading
//                       ? "Loading..."
//                       : formatAmount(patientsSalesTotal.total_checkup_fee)}
//                   </h1>
//                   <p className="font-bold text-xs text-gray-400">PKR</p>
//                 </div>
//               </div>
//               <div className="p-3 bg-white shadow-xl border border-gray-300 rounded-2xl">
//                 <div className="bg-gray-800 flex flex-row gap-2 items-center text-white p-2 rounded-md">
//                   <GiMedicines size={25} />
//                   <p className="font-bold text-xs">Medicines Sales</p>
//                 </div>
//                 <div className="my-6 flex flex-row justify-center">
//                   <h1 className="font-extrabold text-4xl text-center text-[#F07F1B]">
//                     {loading
//                       ? "Loading..."
//                       : formatAmount(medicinesSalesTotal.total_medicines_sale)}
//                   </h1>
//                   <p className="font-bold text-xs text-gray-400">PKR</p>
//                 </div>
//               </div>
//               <div className="p-3 bg-white shadow-xl border border-gray-300 rounded-2xl">
//                 <div className="bg-gray-800 flex flex-row gap-2 items-center text-white p-2 rounded-md">
//                   <BiSolidInjection size={25} />
//                   <p className="font-bold text-xs">Services Sales</p>
//                 </div>
//                 <div className="my-6 flex flex-row justify-center">
//                   <h1 className="font-extrabold text-4xl text-center text-[#F07F1B]">
//                     {loading
//                       ? "Loading..."
//                       : formatAmount(servicesSalesTotal.total_medicines_sale)}
//                   </h1>
//                   <p className="font-bold text-xs text-gray-400">PKR</p>
//                 </div>
//               </div>
//               <div className="p-3 bg-white shadow-xl border border-gray-300 rounded-2xl">
//                 <div className="bg-gray-800 flex flex-row gap-2 items-center text-white p-2 rounded-md">
//                   <MdLocalHospital size={25} />
//                   <p className="font-bold text-xs">Pharmacy Sales</p>
//                 </div>
//                 <div className="my-6 flex flex-row justify-center">
//                   <h1 className="font-extrabold text-4xl text-center text-[#F07F1B]">
//                     {loading
//                       ? "Loading..."
//                       : formatAmount(pharmacySalesTotal.total_amount)}
//                   </h1>
//                   <p className="font-bold text-xs text-gray-400">PKR</p>
//                 </div>
//               </div>
//             </div>
//             <div className="w-[28%] bg-white p-4 rounded-2xl border border-gray-300 shadow-xl">
//               {/* <div className="flex flex-row gap-2 items-center">
//             <div className="w-2 h-2 bg-black rounded-full"></div>
//               <h1 className="font-bold text-sm">Sales and Purchases</h1>
//             </div> */}
//               <div className="mt-4">
//                 <DoughnutChart />
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Pie Chart here */}
//       </div>
//       <div className="w-full flex flex-row items-center gap-4 mt-8 mb-8">
//         <div className="w-[50%] box-border bg-white shadow-xl rounded-2xl border border-gray-300 p-6">
//           <div>
//             <LineChart />
//           </div>
//         </div>
//         <div className="w-[50%] box-border bg-white shadow-xl rounded-2xl border border-gray-300 p-6">
//           <div>
//             <BarChart />
//           </div>
//         </div>
//       </div>
//       <div className="thirdContainer">
//         <div
//           className="container flex justify-between gap-4"
//           style={{ boxShadow: "0 0 4px rgba(0, 0, 0, 0.2)" }}
//         >
//           <div className="amountReceived w-full">
//             <div
//               style={{ display: "flex", gap: 10, paddingLeft: 20 }}
//               className="py-4"
//             >
//               <h4 className=" font-[600]">Recent Sales</h4>
//             </div>
//             <div className="paid">
//               <div
//                 className="bg-white rounded-lg shadow-md p-4 flex justify-start w-full"
//                 style={{
//                   borderRadius: "5px",
//                   boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
//                 }}
//               >
//                 <table className="table-auto w-auto text-left text-gray-600 text-sm">
//                   <thead>
//                     <tr className="bg-gray-100">
//                       <th colSpan="1" className="p-2 text-center">
//                         Date
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {patientsSales.map((item, index) => (
//                       <tr key={index} className="hover:bg-gray-50 text-xs">
//                         <td className="p-2 whitespace-nowrap font-bold">
//                           {/* {item.date} */}
//                           {formatDate(item.date)}
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//                 <table className="table-auto w-full text-left text-gray-600 text-sm">
//                   <thead>
//                     <tr className="bg-gray-100">
//                       <th colSpan="3" className="p-2 text-center">
//                         Patient Sales
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {patientsSales.map((item, index) => (
//                       <tr
//                         key={index}
//                         className="hover:bg-gray-50 text-xs text-center"
//                       >
//                         <td className="p-2 w-[10%] whitespace-nowrap border-l-2">
//                           {item.totalPatients} Invoices
//                         </td>
//                         <td className="p-2 w-[10%] text-center text-green-600 font-bold whitespace-nowrap">
//                           Rs.{item.totalAmount}
//                         </td>
//                         <td className="p-2 w-[10%] whitespace-nowrap border-r-2 py-1">
//                           <button
//                             onClick={() => handleViewPatients(item.sales)}
//                             className="text-gray-700"
//                           >
//                             <AiOutlineEye size={16} />
//                           </button>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//                 <table className="table-auto w-full text-left text-gray-600 text-sm">
//                   <thead>
//                     <tr className="bg-gray-100">
//                       <th colSpan="3" className="p-2 text-center">
//                         Medicine Sales
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {medicinesGroupedData?.map((item, index) => (
//                       <tr
//                         key={index}
//                         className="hover:bg-gray-50 text-xs text-center"
//                       >
//                         <td className="p-2 w-[10%] whitespace-nowrap">
//                           {item?.totalInvoiceCount} Invoices
//                         </td>
//                         <td className="p-2 w-[10%] text-center text-green-600 font-bold whitespace-nowrap">
//                           Rs.{item?.totalAmount}
//                         </td>
//                         <td className="p-2 w-[10%] whitespace-nowrap">
//                           <button
//                             onClick={() => handleMViewInvoices(item.date)}
//                             className="text-gray-700"
//                           >
//                             <AiOutlineEye size={16} />
//                           </button>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//                 <table className="table-auto w-full text-left text-gray-600 text-sm">
//                   <thead>
//                     <tr className="bg-gray-100">
//                       <th colSpan="3" className="p-2 text-center">
//                         Services Sales
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {servicesGroupedData?.map((item, index) => (
//                       <tr
//                         key={index}
//                         className="hover:bg-gray-50 text-xs text-center"
//                       >
//                         <td className="p-2 w-[10%] whitespace-nowrap border-l-2">
//                           {item?.totalInvoiceCount} Invoices
//                         </td>
//                         <td className="p-2 w-[10%] text-center text-green-600 font-bold whitespace-nowrap">
//                           Rs.{item?.totalAmount}
//                         </td>
//                         <td className="p-2 w-[10%] whitespace-nowrap">
//                           <button
//                             onClick={() => handleViewInvoices(item.date)}
//                             className="text-gray-700"
//                           >
//                             <AiOutlineEye size={16} />
//                           </button>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>

//                 <table className="table-auto w-full text-left text-gray-600 text-sm">
//                   <thead>
//                     <tr className="bg-gray-100">
//                       <th colSpan="3" className="p-2 text-center">
//                         Pharmacy Sales
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {loading ? (
//                       <tr>
//                         <td colSpan="3" className="text-center p-4">
//                           Loading sales...
//                         </td>
//                       </tr>
//                     ) : (
//                       pharmacySales.map((item, index) => (
//                         <tr
//                           key={index}
//                           className="hover:bg-gray-50 text-xs text-center"
//                         >
//                           <td className="p-2 w-[10%] whitespace-nowrap border-l-2">
//                             {item.invoiceCount}{" "}
//                             {item.invoiceCount === 1 ? "Invoice" : "Invoices"}
//                           </td>
//                           <td className="p-2 w-[10%] text-center text-green-600 font-bold whitespace-nowrap">
//                             Rs.{item.totalAmount.toFixed(2)}
//                           </td>
//                           <td className="p-2 w-[10%] whitespace-nowrap">
//                             <button
//                               onClick={() =>
//                                 handleViewPharmacyInvoice(item.date)
//                               }
//                               className="text-gray-700"
//                             >
//                               <AiOutlineEye size={16} />
//                             </button>
//                           </td>
//                         </tr>
//                       ))
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>

//             <PatientsModal
//               isOpen={isPModalOpen}
//               onClose={() => setIsPModalOpen(false)}
//               patients={selectedPatients}
//             />

//             <ServicesInvoiceModal
//               isOpen={isModalOpen}
//               onClose={() => setIsModalOpen(false)}
//               invoices={selectedInvoices}
//             />

//             <MedicinesInvoiceModal
//               isOpen={isMModalOpen}
//               onClose={() => setMIsModalOpen(false)}
//               invoices={selectedMInvoices}
//             />

//             {isPharmacyModalOpen && (
//               <PharmacyInvoicesModal
//                 invoices={selectedPharmacyInvoices}
//                 onClose={handleCloseModal}
//               />
//             )}
//           </div>
//         </div>
//         <div className="purchaseContainer"></div>
//       </div>
//     </div>
//   );
// };

// export default AdminDashboard;

import React, { useState, useEffect } from "react";
import { FaArrowUp, FaDollarSign, FaWallet } from "react-icons/fa";
import {
  MdCreditScore,
  MdLocalHospital,
  MdOutlineAutoGraph,
  MdPeopleAlt,
} from "react-icons/md";
import toast from "react-hot-toast";
import { Sector } from "recharts";
import { FaArrowDown } from "react-icons/fa";
import { AiOutlineEye, AiOutlineStock } from "react-icons/ai";
import { IoLocationSharp } from "react-icons/io5";
import { RiExchangeDollarLine } from "react-icons/ri";
import { BsBank2 } from "react-icons/bs";
import { IoMdCash } from "react-icons/io";
import {
  FaMoneyCheckDollar,
  FaSackDollar,
  FaUserDoctor,
} from "react-icons/fa6";
import doctorService from "../../Services/doctorService";
import { PeopleAltOutlined, Shop, ShoppingBag } from "@mui/icons-material";
import patientService from "../../Services/patientService";
import saleService from "../../Services/saleService";
import staffService from "../../Services/staffService";
import ServicesInvoiceModal from "../../Components/ServicesInvoiceModal";
import MedicinesInvoiceModal from "../../Components/MedicinesInvoiceModal";
import PatientsModal from "../../Components/PatientsModal";
import PharmacyInvoicesModal from "../../Components/PharmacyInvoicesModal ";
import pnlService from "../../Services/pnlService";
import { TbBedFlatFilled } from "react-icons/tb";
import { GiMedicines } from "react-icons/gi";
import { BiSolidInjection } from "react-icons/bi";
import DoughnutChart from "../../Components/DoughnutChart";
import LineChart from "../../Components/LineChart";
import BarChart from "../../Components/BarChart";

const AdminDashboard = () => {
  const [select, setselect] = useState(false);
  const [activeIndex, setactiveIndex] = useState(0);
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(false);
  const [doctors, setDoctors] = useState([]);
  const [sales, setSales] = useState([]);
  const [todayProfit, setTodayProfit] = useState([]);
  const [salesInvoices, setSalesInvoices] = useState([]);
  const [monthSales, setMonthSales] = useState([]);

  const [patientsSales, setPatientsSales] = useState([]);
  const [medicineSales, setMedicineSales] = useState([]);
  const [servicesSales, setServicesSales] = useState([]);
  const [staffTotal, setStaffTotal] = useState([]);

  const [feeTotal, setFeeTotal] = useState([]);
  const [mSalesTotal, setMSalesTotal] = useState([]);
  const [patientsSalesTotal, setPatientsSalesTotal] = useState([]);
  const [medicinesSalesTotal, setMedicinesSalesTotal] = useState([]);
  const [servicesSalesTotal, setServicesSalesTotal] = useState([]);
  const [pharmacySalesTotal, setPharmacySalesTotal] = useState([]);

  const [price, setPrice] = useState("");
  const [medicinesGroupedData, setMedicinesGroupedData] = useState([]);
  const [servicesGroupedData, setServicesGroupedData] = useState([]);
  const [pharmacyGroupedData, setPharmacyGroupedData] = useState([]);

  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [selectedMInvoices, setSelectedMInvoices] = useState([]);
  const [isMModalOpen, setMIsModalOpen] = useState(false);

  const [selectedPatients, setSelectedPatients] = useState([]);
  const [isPModalOpen, setIsPModalOpen] = useState(false);
  const [totalPatients, setTotalPatients] = useState(0);
  const [pharmacySales, setPharmacySales] = useState([]);

  const [selectedPharmacyInvoices, setSelectedPharmacyInvoices] =
    useState(null);
  const [isPharmacyModalOpen, setIsPharmacyModalOpen] = useState(false);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString("en-PK", options);
  };

  useEffect(() => {
    const getDoctors = async () => {
      try {
        setLoading(true);
        const response = await doctorService.fetchTotal();
        setDoctors(response.total);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error("Error fetching doctors");
      }
    };
    getDoctors();
  }, []);

  useEffect(() => {
    const getPatients = async () => {
      try {
        setLoading(true);
        const response = await patientService.fetchTotal();
        setPatients(response.total);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error("Error fetching patients");
      }
    };
    getPatients();
  }, []);

  useEffect(() => {
    const getStaff = async () => {
      try {
        setLoading(true);
        const response = await staffService.fetchTotal();
        setStaffTotal(response.total);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error("Error fetching staff");
      }
    };
    getStaff();
  }, []);

  useEffect(() => {
    const getFees = async () => {
      try {
        setLoading(true);
        const response = await saleService.fetchPnl();
        setFeeTotal(response.Checkup_Fee);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error("Error fetching fees");
      }
    };
    getFees();
  }, []);

  useEffect(() => {
    const getSalesTotal = async () => {
      try {
        setLoading(true);
        const response = await saleService.fetchPnl();
        setMSalesTotal(response.total_medicine_services_sale);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error("Error fetching sales total");
      }
    };
    getSalesTotal();
  }, []);

  useEffect(() => {
    const getPSales = async () => {
      try {
        setLoading(true);
        const response = await saleService.fetchAllPatients();
        const sortedSales = response.sales.sort(
          (a, b) => new Date(b.date) - new Date(a.date),
        );
        const thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
        thirtyDaysAgo.setHours(0, 0, 0, 0);
        const filteredSales = sortedSales.filter((sale) => {
          const saleDate = new Date(sale.date);
          return saleDate >= thirtyDaysAgo;
        });
        const groupedSales = filteredSales.reduce((acc, sale) => {
          const date = formatDate(sale.date);
          if (!acc[date])
            acc[date] = { totalAmount: 0, totalPatients: 0, sales: [] };
          acc[date].totalAmount += sale.fee;
          acc[date].totalPatients += 1;
          acc[date].sales.push(sale);
          return acc;
        }, {});
        setPatientsSales(
          Object.entries(groupedSales).map(([date, data]) => ({
            date,
            totalAmount: data.totalAmount,
            totalPatients: data.totalPatients,
            sales: data.sales,
          })),
        );
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching sales:", error);
      }
    };
    getPSales();
  }, []);

  const handleViewPatients = (sales) => {
    setSelectedPatients(sales);
    setIsPModalOpen(true);
  };

  useEffect(() => {
    const fetchSalesData = async () => {
      try {
        setLoading(true);
        const response = await saleService.fetchAllMedicinesSales();
        const thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
        thirtyDaysAgo.setHours(0, 0, 0, 0);
        const recentSales = response.sales.filter((sale) => {
          const saleDate = new Date(sale.sale_date);
          return saleDate >= thirtyDaysAgo;
        });
        const grouped = groupByDate(recentSales);
        setMedicinesGroupedData(grouped);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error("Error fetching medicines sales data");
      }
    };
    fetchSalesData();
  }, []);

  useEffect(() => {
    const fetchSalesData = async () => {
      try {
        setLoading(true);
        const response = await saleService.fetchAllServicesSale();
        const thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
        thirtyDaysAgo.setHours(0, 0, 0, 0);
        const recentSales = response.sales.filter((sale) => {
          const saleDate = new Date(sale.sale_date);
          return saleDate >= thirtyDaysAgo;
        });
        const grouped = groupByDate(recentSales);
        setServicesGroupedData(grouped);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error("Error fetching services sales data");
      }
    };
    fetchSalesData();
  }, []);

  useEffect(() => {
    const fetchAllPharmacySales = async () => {
      try {
        setLoading(true);
        const response = await saleService.fetchAllPharmacySales();
        const today = new Date();
        const last30Days = [];
        for (let i = 29; i >= 0; i--) {
          const date = new Date();
          date.setDate(today.getDate() - i);
          last30Days.push(date.toLocaleDateString());
        }
        let groupedSales = {};
        if (response && response.sales) {
          groupedSales = response.sales.reduce((acc, sale) => {
            const saleDate = new Date(sale.date).toLocaleDateString();
            if (!acc[saleDate]) {
              acc[saleDate] = {
                date: saleDate,
                totalAmount: 0,
                invoiceCount: 0,
                invoices: [],
              };
            }
            acc[saleDate].totalAmount += parseFloat(sale.amount);
            acc[saleDate].invoiceCount += 1;
            acc[saleDate].invoices.push(sale);
            return acc;
          }, {});
        }
        let formattedData = last30Days.map((date) => ({
          date,
          totalAmount: groupedSales[date]?.totalAmount || 0,
          invoiceCount: groupedSales[date]?.invoiceCount || 0,
          invoices: groupedSales[date]?.invoices || [],
        }));
        formattedData.reverse();
        setPharmacySales(formattedData);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching all sales:", error);
        setLoading(false);
      }
    };
    fetchAllPharmacySales();
  }, []);

  const handleViewPharmacyInvoice = (date) => {
    const selectedData = pharmacySales.find((item) => item.date === date);
    setSelectedPharmacyInvoices(selectedData?.invoices || []);
    setIsPharmacyModalOpen(true);
  };

  const groupByDate = (sales) => {
    const dateMap = {};
    const allDates = getAllDatesInRange();
    sales.forEach((sale) => {
      const { invoice, unit_price, quantity, sale_date } = sale;
      const total = quantity * unit_price;
      const dateKey = formatDate(sale_date);
      if (!dateMap[dateKey]) {
        dateMap[dateKey] = {
          date: dateKey,
          totalAmount: 0,
          invoices: new Set(),
        };
      }
      dateMap[dateKey].totalAmount += total;
      dateMap[dateKey].invoices.add(invoice);
    });
    allDates.forEach((date) => {
      if (!dateMap[date]) {
        dateMap[date] = { date, totalAmount: 0, invoices: new Set() };
      }
    });
    return Object.values(dateMap)
      .map((group) => ({ ...group, totalInvoiceCount: group.invoices.size }))
      .sort((a, b) => new Date(b.date) - new Date(a.date));
  };

  const getAllDatesInRange = () => {
    const today = new Date();
    const allDates = [];
    for (let i = 0; i < 30; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() - i);
      allDates.push(formatDate(date));
    }
    return allDates;
  };

  const handleViewInvoices = async (date) => {
    try {
      const response = await saleService.fetchAllServicesSale();
      const filteredInvoices = response.sales.filter(
        (sale) => formatDate(sale.sale_date) === date,
      );
      setSelectedInvoices(filteredInvoices);
      setIsModalOpen(true);
    } catch (error) {
      console.error("Error fetching invoices:", error);
    }
  };

  const handleMViewInvoices = async (date) => {
    try {
      const response = await saleService.fetchAllMedicinesSales();
      const filteredInvoices = response.sales.filter(
        (sale) => formatDate(sale.sale_date) === date,
      );
      setSelectedMInvoices(filteredInvoices);
      setMIsModalOpen(true);
    } catch (error) {
      console.error("Error fetching invoices:", error);
    }
  };

  const formatAmount = (amount) => {
    return parseInt(amount || 0).toLocaleString();
  };

  const handleCloseModal = () => {
    setSelectedPharmacyInvoices(null);
    setIsPharmacyModalOpen(false);
  };

  useEffect(() => {
    const fetchPatientsSales = async () => {
      try {
        setLoading(true);
        const response = await pnlService.fetchCheckupbyMonth();
        if (response.responseCode === 200) {
          const latestMonth = response.Medicines.reduce((latest, current) =>
            new Date(`${current.year}-${current.month_name}-01`) >
            new Date(`${latest.year}-${latest.month_name}-01`)
              ? current
              : latest,
          );
          setPatientsSalesTotal({
            total_checkup_fee: latestMonth.total_checkup_fee,
            month_name: latestMonth.month_name,
          });
        } else {
          toast.error("Failed to fetch Checkup data");
        }
      } catch (error) {
        toast.error("Error fetching Checkup data");
      } finally {
        setLoading(false);
      }
    };
    fetchPatientsSales();
  }, []);

  useEffect(() => {
    const fetchMedicinesSales = async () => {
      try {
        setLoading(true);
        const response = await pnlService.fetchMedicinebyMonth();
        if (response.responseCode === 200) {
          const latestMonth = response.Medicines.reduce((latest, current) =>
            new Date(`${current.year}-${current.month_name}-01`) >
            new Date(`${latest.year}-${latest.month_name}-01`)
              ? current
              : latest,
          );
          setMedicinesSalesTotal({
            total_medicines_sale: latestMonth.total_medicines_sale,
            month_name: latestMonth.month_name,
          });
        } else {
          toast.error("Failed to fetch Medicine data");
        }
      } catch (error) {
        toast.error("Error fetching Medicine data");
      } finally {
        setLoading(false);
      }
    };
    fetchMedicinesSales();
  }, []);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        setLoading(true);
        const response = await pnlService.fetchServicesbyMonth();
        if (response.responseCode === 200) {
          const latestMonth = response.Services.reduce((latest, current) =>
            new Date(`${current.year}-${current.month_name}-01`) >
            new Date(`${latest.year}-${latest.month_name}-01`)
              ? current
              : latest,
          );
          setServicesSalesTotal({
            total_medicines_sale: latestMonth.total_medicines_sale,
            month_name: latestMonth.month_name,
          });
        } else {
          toast.error("Failed to fetch services data");
        }
      } catch (error) {
        toast.error("Error fetching services data");
      } finally {
        setLoading(false);
      }
    };
    fetchServices();
  }, []);

  useEffect(() => {
    const fetchPharmacy = async () => {
      try {
        setLoading(true);
        const response = await pnlService.fetchPharmacybyMonth();
        if (response.responseCode === 200) {
          const latestMonth = response.Pharmacy.reduce((latest, current) =>
            new Date(`${current.year}-${current.month_name}-01`) >
            new Date(`${latest.year}-${latest.month_name}-01`)
              ? current
              : latest,
          );
          setPharmacySalesTotal({
            total_amount: latestMonth.total_amount,
            month_name: latestMonth.month_name,
          });
        } else {
          toast.error("Failed to fetch Pharmacy data");
        }
      } catch (error) {
        toast.error("Error fetching Pharmacy data");
      } finally {
        setLoading(false);
      }
    };
    fetchPharmacy();
  }, []);

  // ─── Stat Card component for reuse ───────────────────────────────────────────
  const StatCard = ({ icon: Icon, label, value, unit }) => (
    <div className="p-3 bg-white shadow-xl border border-gray-300 rounded-2xl">
      <div className="bg-[#215187] flex flex-row gap-2 items-center text-white p-2 rounded-md">
        <Icon size={20} className="shrink-0" />
        <p className="font-bold text-xs truncate">{label}</p>
      </div>
      <div className="my-4 sm:my-6 flex flex-row justify-center items-end gap-1">
        <h1 className="font-extrabold text-2xl sm:text-3xl lg:text-4xl text-center text-black leading-none">
          {loading ? (
            <span className="text-base text-gray-400">Loading...</span>
          ) : (
            value
          )}
        </h1>
        {unit && !loading && (
          <p className="font-bold text-xs text-gray-400 mb-1">{unit}</p>
        )}
      </div>
    </div>
  );

  // ─── Sales table section ──────────────────────────────────────────────────────
  const SalesSection = ({ title, rows }) => (
    <div className="mb-4">
      <h3 className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-1 px-1">
        {title}
      </h3>
      <div className="overflow-x-auto rounded-lg border border-gray-200">
        <table className="table-auto w-full text-left text-gray-600 text-xs">
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan="3" className="text-center p-3 text-gray-400">
                  No data
                </td>
              </tr>
            ) : (
              rows
            )}
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <div className="p-2 sm:p-4">
      {/* ── TOP STATS + DONUT ───────────────────────────────────────────────────── */}
      <div className="flex flex-col lg:flex-row gap-4">
        <div className="w-full lg:w-[70%] grid grid-cols-2 sm:grid-cols-3 gap-3">
          <StatCard
            icon={TbBedFlatFilled}
            label="Total Patients"
            value={patients}
          />
          <StatCard icon={MdPeopleAlt} label="Total Staff" value={staffTotal} />
          <StatCard
            icon={FaUserDoctor}
            label="Patients Sales"
            value={formatAmount(patientsSalesTotal.total_checkup_fee)}
            unit="PKR"
          />
          <StatCard
            icon={GiMedicines}
            label="Medicines Sales"
            value={formatAmount(medicinesSalesTotal.total_medicines_sale)}
            unit="PKR"
          />
          <StatCard
            icon={BiSolidInjection}
            label="Services Sales"
            value={formatAmount(servicesSalesTotal.total_medicines_sale)}
            unit="PKR"
          />
          <StatCard
            icon={MdLocalHospital}
            label="Pharmacy Sales"
            value={formatAmount(pharmacySalesTotal.total_amount)}
            unit="PKR"
          />
        </div>

        {/* Donut chart */}
        <div className="w-full lg:w-[28%] bg-white p-4 rounded-2xl border border-gray-300 shadow-xl">
          <div className="mt-2 sm:mt-4">
            <DoughnutChart />
          </div>
        </div>
      </div>

      {/* ── LINE + BAR CHARTS ────────────────────────────────────────────────────── */}
      <div className="flex flex-col sm:flex-row gap-4 mt-6 mb-6">
        <div className="w-full sm:w-1/2 bg-white shadow-xl rounded-2xl border border-gray-300 p-4 overflow-hidden">
          <LineChart />
        </div>
        <div className="w-full sm:w-1/2 bg-white shadow-xl rounded-2xl border border-gray-300 p-4 overflow-hidden">
          <BarChart />
        </div>
      </div>

      {/* ── RECENT SALES TABLE ────────────────────────────────────────────────────── */}
      <div
        className="bg-white rounded-xl shadow-md p-3 sm:p-5"
        style={{ boxShadow: "0 0 4px rgba(0, 0, 0, 0.2)" }}
      >
        <h4 className="font-semibold text-sm sm:text-base mb-4 px-1">
          Recent Sales
        </h4>

        {/* ── MOBILE STACKED VIEW (< sm) ─────────────────────────── */}
        <div className="block sm:hidden space-y-4">
          {/* Patient Sales */}
          <SalesSection
            title="Patient Sales"
            rows={patientsSales.map((item, index) => (
              <tr
                key={index}
                className="border-b last:border-0 hover:bg-gray-50"
              >
                <td className="p-2 font-bold text-gray-700 whitespace-nowrap">
                  {formatDate(item.date)}
                </td>
                <td className="p-2 whitespace-nowrap">
                  {item.totalPatients} Inv.
                </td>
                <td className="p-2 text-green-600 font-bold whitespace-nowrap">
                  Rs.{item.totalAmount}
                </td>
                <td className="p-2">
                  <button
                    onClick={() => handleViewPatients(item.sales)}
                    className="text-gray-600 hover:text-gray-900"
                  >
                    <AiOutlineEye size={16} />
                  </button>
                </td>
              </tr>
            ))}
          />

          {/* Medicine Sales */}
          <SalesSection
            title="Medicine Sales"
            rows={medicinesGroupedData?.map((item, index) => (
              <tr
                key={index}
                className="border-b last:border-0 hover:bg-gray-50"
              >
                <td className="p-2 font-bold text-gray-700 whitespace-nowrap">
                  {item.date}
                </td>
                <td className="p-2 whitespace-nowrap">
                  {item?.totalInvoiceCount} Inv.
                </td>
                <td className="p-2 text-green-600 font-bold whitespace-nowrap">
                  Rs.{item?.totalAmount}
                </td>
                <td className="p-2">
                  <button
                    onClick={() => handleMViewInvoices(item.date)}
                    className="text-gray-600 hover:text-gray-900"
                  >
                    <AiOutlineEye size={16} />
                  </button>
                </td>
              </tr>
            ))}
          />

          {/* Services Sales */}
          <SalesSection
            title="Services Sales"
            rows={servicesGroupedData?.map((item, index) => (
              <tr
                key={index}
                className="border-b last:border-0 hover:bg-gray-50"
              >
                <td className="p-2 font-bold text-gray-700 whitespace-nowrap">
                  {item.date}
                </td>
                <td className="p-2 whitespace-nowrap">
                  {item?.totalInvoiceCount} Inv.
                </td>
                <td className="p-2 text-green-600 font-bold whitespace-nowrap">
                  Rs.{item?.totalAmount}
                </td>
                <td className="p-2">
                  <button
                    onClick={() => handleViewInvoices(item.date)}
                    className="text-gray-600 hover:text-gray-900"
                  >
                    <AiOutlineEye size={16} />
                  </button>
                </td>
              </tr>
            ))}
          />

          {/* Pharmacy Sales */}
          <SalesSection
            title="Pharmacy Sales"
            rows={
              loading
                ? [
                    <tr key="loading">
                      <td colSpan="4" className="text-center p-4 text-gray-400">
                        Loading sales...
                      </td>
                    </tr>,
                  ]
                : pharmacySales.map((item, index) => (
                    <tr
                      key={index}
                      className="border-b last:border-0 hover:bg-gray-50"
                    >
                      <td className="p-2 font-bold text-gray-700 whitespace-nowrap">
                        {item.date}
                      </td>
                      <td className="p-2 whitespace-nowrap">
                        {item.invoiceCount}{" "}
                        {item.invoiceCount === 1 ? "Inv." : "Invs."}
                      </td>
                      <td className="p-2 text-green-600 font-bold whitespace-nowrap">
                        Rs.{item.totalAmount.toFixed(2)}
                      </td>
                      <td className="p-2">
                        <button
                          onClick={() => handleViewPharmacyInvoice(item.date)}
                          className="text-gray-600 hover:text-gray-900"
                        >
                          <AiOutlineEye size={16} />
                        </button>
                      </td>
                    </tr>
                  ))
            }
          />
        </div>

        {/* ── TABLET / DESKTOP HORIZONTAL TABLE (>= sm) ── */}
        <div className="hidden sm:block overflow-x-auto">
          <div className="inline-flex gap-0 min-w-full">
            {/* Date column */}
            <table className="table-auto text-left text-gray-600 text-xs shrink-0">
              <thead>
                <tr className="bg-gray-100">
                  <th className="p-2 text-center whitespace-nowrap">Date</th>
                </tr>
              </thead>
              <tbody>
                {patientsSales.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="p-2 whitespace-nowrap font-bold">
                      {formatDate(item.date)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Patient Sales */}
            <table className="table-auto w-full text-left text-gray-600 text-xs">
              <thead>
                <tr className="bg-gray-100">
                  <th colSpan="3" className="p-2 text-center whitespace-nowrap">
                    Patient Sales
                  </th>
                </tr>
              </thead>
              <tbody>
                {patientsSales.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50 text-center">
                    <td className="p-2 whitespace-nowrap border-l-2">
                      {item.totalPatients} Invoices
                    </td>
                    <td className="p-2 text-green-600 font-bold whitespace-nowrap">
                      Rs.{item.totalAmount}
                    </td>
                    <td className="p-2 whitespace-nowrap border-r-2 py-1">
                      <button
                        onClick={() => handleViewPatients(item.sales)}
                        className="text-gray-700"
                      >
                        <AiOutlineEye size={16} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Medicine Sales */}
            <table className="table-auto w-full text-left text-gray-600 text-xs">
              <thead>
                <tr className="bg-gray-100">
                  <th colSpan="3" className="p-2 text-center whitespace-nowrap">
                    Medicine Sales
                  </th>
                </tr>
              </thead>
              <tbody>
                {medicinesGroupedData?.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50 text-center">
                    <td className="p-2 whitespace-nowrap">
                      {item?.totalInvoiceCount} Invoices
                    </td>
                    <td className="p-2 text-green-600 font-bold whitespace-nowrap">
                      Rs.{item?.totalAmount}
                    </td>
                    <td className="p-2 whitespace-nowrap">
                      <button
                        onClick={() => handleMViewInvoices(item.date)}
                        className="text-gray-700"
                      >
                        <AiOutlineEye size={16} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Services Sales */}
            <table className="table-auto w-full text-left text-gray-600 text-xs">
              <thead>
                <tr className="bg-gray-100">
                  <th colSpan="3" className="p-2 text-center whitespace-nowrap">
                    Services Sales
                  </th>
                </tr>
              </thead>
              <tbody>
                {servicesGroupedData?.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50 text-center">
                    <td className="p-2 whitespace-nowrap border-l-2">
                      {item?.totalInvoiceCount} Invoices
                    </td>
                    <td className="p-2 text-green-600 font-bold whitespace-nowrap">
                      Rs.{item?.totalAmount}
                    </td>
                    <td className="p-2 whitespace-nowrap">
                      <button
                        onClick={() => handleViewInvoices(item.date)}
                        className="text-gray-700"
                      >
                        <AiOutlineEye size={16} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Pharmacy Sales */}
            <table className="table-auto w-full text-left text-gray-600 text-xs">
              <thead>
                <tr className="bg-gray-100">
                  <th colSpan="3" className="p-2 text-center whitespace-nowrap">
                    Pharmacy Sales
                  </th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="3" className="text-center p-4">
                      Loading sales...
                    </td>
                  </tr>
                ) : (
                  pharmacySales.map((item, index) => (
                    <tr key={index} className="hover:bg-gray-50 text-center">
                      <td className="p-2 whitespace-nowrap border-l-2">
                        {item.invoiceCount}{" "}
                        {item.invoiceCount === 1 ? "Invoice" : "Invoices"}
                      </td>
                      <td className="p-2 text-green-600 font-bold whitespace-nowrap">
                        Rs.{item.totalAmount.toFixed(2)}
                      </td>
                      <td className="p-2 whitespace-nowrap">
                        <button
                          onClick={() => handleViewPharmacyInvoice(item.date)}
                          className="text-gray-700"
                        >
                          <AiOutlineEye size={16} />
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* ── MODALS ────────────────────────────────────────────────────────────────── */}
      <PatientsModal
        isOpen={isPModalOpen}
        onClose={() => setIsPModalOpen(false)}
        patients={selectedPatients}
      />
      <ServicesInvoiceModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        invoices={selectedInvoices}
      />
      <MedicinesInvoiceModal
        isOpen={isMModalOpen}
        onClose={() => setMIsModalOpen(false)}
        invoices={selectedMInvoices}
      />
      {isPharmacyModalOpen && (
        <PharmacyInvoicesModal
          invoices={selectedPharmacyInvoices}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};

export default AdminDashboard;
